import Swal from 'sweetalert2'

export const userKey = '_Sollicita.Capacitacao'
export const rememberKey = '_Sollicita.Capacitacao_remember'

export var urlApi = ''
export var urlApiSollicita = ''
//export var idModulo = 41
export var idModulo = 30
export var cdProduto = 'SC'
export var carrinhoKey = '_Sollicita.Capacitacao.carrinho'

var urlBase = 'sollicita.com.br';

export var linkPlanos = 'https://' + urlBase +'/Planos'
export var linkPortal = 'https://portal.' + urlBase + '/'
export var linkFerramentas = 'https://' + urlBase + '/'

var dev = false;
if (dev) {
    urlApi = 'https://localhost:44324/api/v1'
    urlApiSollicita = 'http://localhost:82/NP/SollicitaAdmin/api'
} else {
    urlApi = 'https://api.' + urlBase+'/api/v1'
    urlApiSollicita = 'https://gnp.negociospublicos.net.br/NP/SollicitaAdmin/api'
}

export function avisoErro(e) {
    if (e && e.response && e.response.data) {
        //alert(e.response.data);
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: e.response.data,
        })
    } else if (typeof e === 'string') {
        //alert(e);
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: e,
        })
    } else {
        //alert('Erro');
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: e,
        })
    }
}

export function avisoSucesso(msg) {
    Swal.fire({
        icon: 'success',
        title: 'Sucesso',
        text: msg,
    })
}

export function avisoToast(msg, icon = 'success') {
    
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    Toast.fire({
        icon: icon,
        title: msg
    })
}


export function numeroParaMoeda(n, c, d, t) {
    let s, i, j;
    c = isNaN(c = Math.abs(c)) ? 2 : c, d = d == undefined ? "," : d, t = t == undefined ? "." : t, s = n < 0 ? "-" : "", i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "", j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
}

export function moedaParaNumero(valor) {
    return isNaN(valor) == false ? parseFloat(valor) : parseFloat(valor.replace("R$", "").replace(/[.]+/g, "").replace(/[,]+/g, "."));
}

export function moedaParaNumeroComCasa(valor, nrCasas) {
    return isNaN(valor) == false ? parseFloat(parseFloat(valor).toFixed(nrCasas)) : parseFloat(parseFloat(valor.replace("R$", "").replace(/[.]+/g, "").replace(/[,]+/g, ".")).toFixed(nrCasas));
}

export function arredondar(num, places) {
    if (!("" + num).includes("e")) {
        return +(Math.round(num + "e+" + places) + "e-" + places);
    } else {
        let arr = ("" + num).split("e");
        let sig = ""
        if (+arr[1] + places > 0) {
            sig = "+";
        }

        return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + places)) + "e-" + places);
    }
}

export default {
    userKey,
    rememberKey,
    urlApi,
    avisoErro,
    avisoSucesso,
    avisoToast,
    urlApiSollicita,
    idModulo,
    linkPortal,
    linkFerramentas,
    carrinhoKey,

    numeroParaMoeda,
    moedaParaNumero,
    moedaParaNumeroComCasa,
    arredondar,
    linkPlanos,
}